// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"99":"485f5336","153":"969b5b20","466":"1ce610bf"}[chunkId] + ".chunk.css";
};